import {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal, Select,Popover, Tag} from "antd";
import {t} from "i18next";
import {
    filterNumericInput, formatDateCharDesc,
    generateUUID2,
    getImagePath, getImagePathSvg,
    getImagePathWithTheme,
    getImagePathWithThemeSvg, isArray,
    isDarkMode, isNumber, isNumberOrFloat,
    isStringNullOrEmpty
} from "../../utils";
import {
    ARRAY_LIBRARY_TYPES_TABLEVIEW, CHECK_ALL,
    getDefaultTagBackgroundColor,
    getElementEditorBorderColor,
    getInputBorderColor, getPropertySelectOptionBackgroundColor,
    IMPORT_FILE_MODE_IMPORTMODE, MENU_SEPARATOR
} from "../../Const";
import {ipcInvoke, ipcSend} from "../../common/ipc";
import {getNoteList} from "@model/note";
import {getTagList} from "@model/tag";
import {isZh} from "@/language";
import {deleteCustomFilter, getCustomFilter, getCustomFilterList, updateCustomFilter} from "@model/customFilter";
import {getPropertyList, getSortPropertyList} from "@model/Property";
import {getFilterOperator, getFilterOptionValue} from "@/UtilityInner";
import PopupDate from "@/views/Property/PopupDate";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";

const DialogCreateNewFilter = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [arrayConditions,setArrayConditions] = useState([]);
    // const [arraySecondFilters,setArraySecondFilters] = useState<any>([]);
    const [customFilter,setCustomFilter] = useState<any>(null);
    const [isNewCustomFilter,setIsNewCustomFilter] = useState(false);
    const [arrayProperties,setArrayProperties] = useState([]);
    const [mapFilterType,setMapFilterType] = useState<any>({});
    const [mapPropertyOpen,setMapPropertyOpen] = useState<any>({});
    const [mapFilterDropdownOpen,setMapFilterDropdownOpen] = useState<any>({});
    const [isFilterSomeOpen,setIsFilterSomeOpen] = useState<any>({});
    const [randomUUID,setRandomUUID] = useState<any>({});

    const mArrayProjects = useRef<any>([]);
    const mArrayTags = useRef<any>([]);
    const inputTitleRef = useRef(null);
    const mSelectIsProperty = useRef(false);
    const mArrayPropertys = useRef<any>(null);

    const ITEM_WIDTH = '175px';

    const GET_ARRAY_PRIMARY_FILTER = ()=>{
        const ARRAY_PRIMARY_FILTER = [
            {
                value:'type',
                label:t("Type"),
                icon:'transparent'
            },
            {
                value:'project',
                label:t("Project"),
                icon:'transparent'
            },
            {
                value:'tag',
                label:t("Tags"),
                icon:'transparent'
            },
            {
                value:'keyword',
                label:t("Keyword"),
                icon:'transparent'
            },
            {
                value:'properties',
                label:t("Properties"),
                icon:'transparent',
            },
        ]
        return ARRAY_PRIMARY_FILTER;
    }


    const ARRAY_SECOND_FILTER_TYPE = [
        {
            value:'card',
            label:t("Card"),
            buttonLabel:t("New card"),
            icon:'library_type_card'
        },
        {
            value:'pdf',
            label:t("PDF"),
            buttonLabel:t("New PDF"),
            ext:'.pdf',
            icon:'library_type_pdf'
        },
        {
            value:'journal',
            label:t("Journal"),
            buttonLabel:t("New journal"),
            icon:'library_type_journal'
        },
        {
            value:'image',
            label:t("Image"),
            buttonLabel:t("New image"),
            ext:'.jpg,.jpeg,.bmp,.png',
            icon:'library_type_image'
        },
        {
            value:'liveVideo',
            label:t("Live video"),
            buttonLabel:'',
            ext:'.mp4,.mov',
            icon:'library_type_online_video'
        },
        {
            value:'video',
            label:t("Video"),
            buttonLabel:t("New video"),
            ext:'.mp4,.mov',
            icon:'library_type_video'
        },
        // {
        //     value:'image',
        //     label:t("Image"),
        //     buttonLabel:t("New image"),
        //     ext:'.jpg,.jpeg,.bmp,.png'
        // },
        {
            value:'audio',
            label:t("Audio"),
            buttonLabel:t("New audio"),
            ext:'.mp3',
            icon:'library_type_audio'
        },
        // {
        //     value:'file',
        //     label:t("File"),
        //     buttonLabel:t("New file"),
        //     ext:'*',
        //     icon:'library_type_file'
        // },
        {
            value:'webLink',
            label:t("Web link"),
            buttonLabel:t("Web link"),
            ext:'*',
            icon:'library_type_weblink'
        },
        {
            value:'cardAnno',
            label:t("Card highlight"),
            buttonLabel:t("Card highlight"),
            icon:'library_type_anno'
        },
        {
            value:'pdfAnno',
            label:t("PDF Highlight"),
            buttonLabel:t("PDF"),
            ext:'.pdf',
            icon:'library_type_anno'
        },
        {
            value:'videoAnno',
            label:t("Video notes"),
            buttonLabel:t("Video"),
            ext:'.mp4',
            icon:'library_type_anno'
        },
        {
            value:'audioAnno',
            label:t("Audio notes"),
            buttonLabel:t("Audio"),
            ext:'.mp3',
            icon:'library_type_anno'
        }
    ]

    const onShowDialog = (szId:any)=>{
        setIsShowDialog(true);
        initData(szId)
        setTimeout(()=>{
            inputTitleRef.current?.focus();
        },100)
    }

    useEffect(() => {
        getSortPropertyList().then(res=>{
            const nTypeIndex = res.findIndex(p=>p.type == 'type');
            res.splice(nTypeIndex,1);
            mArrayPropertys.current = res;
            setArrayProperties(res);
        })
    }, []);

    useEffect(() => {
        document.body.addEventListener('keydown',onKeydown);
        return ()=>{
            document.body.removeEventListener('keydown',onKeydown);
        }
    }, [arrayConditions]);

    function onKeydown(event){
        if (event.key == KEYS.ENTER){
            event.stopPropagation();
            event.preventDefault();
            const btn = document.getElementById('btn-update-filter');
            btn?.click();
        }
    }

    const initData = async (szId:any)=>{
        const arrayProjects:any = await getNoteList();
        mArrayProjects.current.length = 0;
        arrayProjects.forEach(p=>{
            mArrayProjects.current.push({
                value:p.id,
                label:p.name
            })
        })

        const arrayTags = await getTagList();
        mArrayTags.current.length = 0;
        arrayTags.forEach(p=>{
            mArrayTags.current.push({
                value:p.id,
                label:p.name
            })
        })

        if (szId){
            getCustomFilter(szId).then(res=>{
                setCustomFilter(res);
                res.arrayConditions.forEach(p=>{
                    if (p.value == 'type'){
                        p.arraySecondFilters = [...ARRAY_SECOND_FILTER_TYPE]
                    }else if (p.value == 'project'){
                        p.arraySecondFilters = [...mArrayProjects.current]
                    }else if (p.value == 'tag'){
                        p.arraySecondFilters = [...mArrayTags.current];
                    }
                })
                setArrayConditions(res.arrayConditions);
            })
            setIsNewCustomFilter(false);
        }else{
            setCustomFilter({
                id:generateUUID2(),
                name:'',
                arrayConditions:[]
            })
            setIsNewCustomFilter(true);
        }
    }


    const tagRender: any = useCallback((props,p) => {
        const column = mArrayPropertys.current?.find(pp => pp.id == p.value);
        const ttttaaaagggggg =  column?.items?.find(p => p.text == props.label);
        return (
            ttttaaaagggggg?
                <Tag
                    closable={false}
                    onClose={(e) => {

                    }}
                    className={'tableview-tag default-font-size'}
                    style={{
                        background: getPropertySelectOptionBackgroundColor(ttttaaaagggggg.backgroundColor),
                        marginLeft: '0px',
                        color:'var(--text-color)'
                    }}
                >
                    {props.label}
                </Tag>:<></>
        );
    }, []);

    /**
     * 渲染第三级的--如果是property------
     * @param p
     */
    const renderElementByType = (p)=>{
        const column:any = arrayProperties.find(pp => pp.id == p.value);
        const szType = column?.type || column?.id;

        const isDisableInput = (p)=>{
            return p.operator == 'isEmpty' || p.operator == 'isNotEmpty'
        }

        if (szType == 'name' || szType == 'text' ||
            szType == 'url' || szType == 'notes' || szType == 'link' || szType == 'number' || szType == 'rating') {
            return <input id={'txt-filter-' + p.id}
                          className={`input-border ${isDisableInput(p) ? '' : 'input-border-focus'}`}
                          readOnly={p.operator == 'isEmpty' || p.operator == 'isNotEmpty'}
                          value={p.secondValue} style={{flexGrow: '1', flexShrink: '0',width:'100%'}} onChange={(e) => {
                if (isDisableInput(p)) {
                    return;
                }
                let szValue = e.currentTarget.value;
                if (szType == 'number'){
                    szValue = filterNumericInput(e.currentTarget.value)
                    if (szValue && !isNumberOrFloat(szValue)){
                        return;
                    }
                }else if (szType == 'rating'){
                    //只能输入1-5
                    if (szValue && !isNumber(szValue)){
                        return;
                    }
                    if (szValue){
                        const nNumber = parseInt(szValue);
                        if (nNumber <= 0 || nNumber > 5){
                            return;
                        }
                    }

                }

                const arrayNewConditions = [...arrayConditions];
                p.secondValue = szValue;
                setArrayConditions(arrayNewConditions);
            }}/>
        }else if (szType == 'createTime' || szType == 'updateTime' || szType == 'date'){
            return <Popover arrow={false} open={isFilterSomeOpen[p.id]} trigger={['click']}
                            align={{offset: [-10, -12]}} onOpenChange={(e)=>{
                const newOpen = {...isFilterSomeOpen};
                newOpen[p.id] = e;
                setIsFilterSomeOpen(newOpen);
            }}
                            placement={'topLeft'}
                            content={<PopupDate defaultDate={p.secondValue}
                                                from={'filter'}
                                                onDateSelect={(longDate, hasClose = true) => {
                                                    const arrayNewConditions = [...arrayConditions];
                                                    p.secondValue = longDate;
                                                    setArrayConditions(arrayNewConditions);

                                                    const newOpen = {...isFilterSomeOpen};
                                                    newOpen[p.id] = false;
                                                    setIsFilterSomeOpen(newOpen);
                                                }}/>}>
                <div style={{width:'100%'}}
                     className={'cursor-pointer span-single-line input-border flex-row-vertical-center'}>{formatDateCharDesc(p.secondValue)}</div>
            </Popover>
        }else if (szType == 'checkbox'){
            return <Select value={p.secondValue} style={{flexGrow: '1', flexShrink: '0',width:'100%'}}
                           onKeyDown={(e) => {
                               //要屏蔽所有的select
                               if (e.key === 'Enter') {
                                   e.preventDefault();
                                   e.stopPropagation();
                               }
                           }}
                           dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                           suffixIcon={<img className='img-mini-small-10' onClick={() => {
                           }} src={getImagePathWithTheme('drop_down_select')}/>}
                           dropdownStyle={{width: '228px', overflowY: 'auto'}}
                           options={p.arrayValues}
                           optionRender={(option) => {
                               return <div className={'flex-row-vertical-center'} style={{height:'100%',width:'100%'}} onClick={(e) => {
                                   const arrayNewConditions = [...arrayConditions];
                                   p.secondValue = option.value;
                                   setArrayConditions(arrayNewConditions);
                               }}>
                                   <span className={'ml-0'}>{option.label}</span>
                               </div>
                           }}>
            </Select>
        }else if (szType == 'select' || szType == 'multiSelect'){
            const getOptions = ()=>{
                let txt = document.getElementById('txt-select-filter-'+p.id);
                if (txt){
                    let szTxt = txt.value.toLowerCase();
                    return column.items.filter(p=>p.text.toLowerCase().includes(szTxt));
                }
                return column.items;
            }
            return <Select value={p.secondValue}
                           onInputKeyDown={(e) => {
                               //要屏蔽所有的select
                               if (e.key === 'Enter') {
                                   e.preventDefault();
                                   e.stopPropagation();
                               }
                           }}
                           mode={"tags"}
                           showSearch={false}
                           className={'hidden-ant-select-input'}
                           tagRender={(props)=>tagRender(props,p)}
                           open={mapFilterDropdownOpen[`select-${p.id}`]}
                           style={{flexGrow: '1', flexShrink: '0',width:'100%'}}
                           dropdownClassName={'shadow'}
                           onDropdownVisibleChange={(e)=>{
                               const newMap = {...mapFilterDropdownOpen};
                               newMap[`select-${p.id}`] = e;
                               setMapFilterDropdownOpen(newMap);
                           }}
                           suffixIcon={<img className='img-mini-small-10' onClick={() => {
                           }} src={getImagePathWithTheme('drop_down_select')}/>}
                           dropdownStyle={{width: '228px', overflowY: 'auto'}}
                           options={getOptions()}
                           dropdownRender={(menus)=>{
                               return<div className={'flex-col'}>
                                   <input id={'txt-select-filter-'+p.id} className={'input-border input-none'} placeholder={t('SearchForAnOption')} onChange={(e)=>{
                                       const newUUID = {...randomUUID};
                                       newUUID[p.id] = Date.now()+'';
                                       setRandomUUID(newUUID);
                                   }}/>
                                   <div key={randomUUID[p.id]} className={'line'} style={{margin:'0 -12px 6px -12px'}}></div>
                                   {
                                       getOptions().length == 0?<div className={'flex-center'} style={{minHeight:'150px'}}><span>{t('NoResults')}</span></div>:
                                           getOptions().map(option=>{
                                               return<div key={option.id} className={'flex-row-vertical-center cursor-pointer hovered-gray'} style={{height:'36px',padding:'0 6px'}} onClick={(e)=>{
                                                   const arrayNewConditions = [...arrayConditions];
                                                   if (!isArray(p.secondValue)) {
                                                       p.secondValue = [];
                                                   }

                                                   const nIndex = p.secondValue.findIndex(ppp=>ppp == option.text);
                                                   if (nIndex != -1) {
                                                       p.secondValue.splice(nIndex,1);
                                                   }else {
                                                       p.secondValue.push(option.text);
                                                   }
                                                   const arrayNewValue = [...p.secondValue];
                                                   p.secondValue = arrayNewValue;
                                                   setArrayConditions(arrayNewConditions);
                                               }}>
                                                   <span style={{background:getPropertySelectOptionBackgroundColor(option.backgroundColor)}} className={'tableview-tag'}>{t(option.text)}</span>
                                                   {
                                                       p.secondValue?.includes && p.secondValue?.includes(option.text) &&
                                                       <img style={{width: '12px', height: '13px', marginLeft: 'auto'}}
                                                            src={getImagePathSvg('check_blue')}/>
                                                   }

                                               </div>
                                           })
                                   }
                               </div>
                           }}
            >
            </Select>
        }else if (szType == 'tags'){
            return <Select value={p.secondValue} style={{flexGrow: '1', flexShrink: '0',width:'100%'}}
                           virtual={false}
                // mode={"multiple"}
                           dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                           suffixIcon={<img className='img-mini-small-10' onClick={() => {
                           }} src={getImagePathWithTheme('drop_down_select')}/>}
                           dropdownStyle={{width: '228px', overflowY: 'auto'}}
                           options={window.getLibraryTagsOptions()}
                           optionRender={(option) => {
                               return <div className={'flex-row-vertical-center'}
                                           style={{height: '100%', width: '100%'}} onClick={(e) => {
                                   const arrayNewConditions = [...arrayConditions];
                                   p.secondValue = [option.value];
                                   setArrayConditions(arrayNewConditions);
                               }}>
                                   <span className={'ml-0'}>{option.label}</span>
                               </div>
                           }}>
            </Select>
        }else if (szType == 'type'){
            return <Select value={p.secondValue} style={{flexGrow: '1', flexShrink: '0',width:'100%'}}
                           virtual={false}
                           dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                           suffixIcon={<img className='img-mini-small-10' onClick={() => {
                           }} src={getImagePathWithTheme('drop_down_select')}/>}
                           dropdownStyle={{width: '228px', overflowY: 'auto'}}
                           options={ARRAY_LIBRARY_TYPES_TABLEVIEW().filter(p=>p.value != MENU_SEPARATOR && p.value != CHECK_ALL)}
                           optionRender={(option) => {
                               return <div className={'flex-row-vertical-center'}
                                           style={{height: '100%', width: '100%'}} onClick={(e) => {
                                   const arrayNewConditions = [...arrayConditions];
                                   p.secondValue = [option.value];
                                   setArrayConditions(arrayNewConditions);
                               }}>
                                   <span className={'ml-0'}>{option.label}</span>
                               </div>
                           }}>
            </Select>
        }

        return <div className={'input-border'}></div>
    }


    return <Modal width={620} zIndex={2005} bodyStyle={{maxHeight:"600px"}}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title-large'}>{t('CreateNewFilter')}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <span className={'dialog-title'}>{t("Filter name") + ":"}</span>
            <input ref={inputTitleRef} className={'input-border-5f mt-8'} value={customFilter?.name} placeholder={t("MyCustomFilter")} onInput={(e)=>{
                const temp = {...customFilter};
                temp.name = e.currentTarget.value;
                setCustomFilter(temp);
            }}/>

            <div className={'flex-row-vertical-center mt-24'}>
                <span className={'dialog-title'}>{t("Conditions")}</span>
                <div className={'flex-row-vertical-center cursor-pointer'} style={{marginLeft: 'auto'}} onClick={()=>{
                    const newItem:any = {
                        id:generateUUID2(),
                        value:'type',
                        secondValue:'card',
                        arraySecondFilters : [...ARRAY_SECOND_FILTER_TYPE]
                    }
                    const arrayNewConditions:any = [...arrayConditions];
                    arrayNewConditions.push(newItem);
                    setArrayConditions(arrayNewConditions);
                }}>
                    <img className={'img-16'} src={getImagePath('add_blue_filter')}/>
                    <span className={'ml-8'} style={{color: 'var(--primary-color)'}}>{t("Add condition")}</span>
                </div>
            </div>

            <div className={isDarkMode() ? 'drag-dashed-border-dark' : 'drag-dashed-border'}
                 style={{margin: '12px 0',padding:'16px', height: 'auto',minHeight:'70px', width: '100%',display:'flex'}}>
                {
                    arrayConditions.length == 0 &&
                    <div className={'flex-center'} style={{
                        color: 'var(--color-666666)',
                        alignSelf: 'center',
                        placeSelf: 'center',
                        justifySelf: 'center',
                        width: '100%'
                    }}>{t("NoConditionsYet")}</div>
                }

                <div className={'flex-col'} style={{gap:'12px',overflowX:'hidden',overflowY:'auto',maxHeight:'300px',margin:'0 -16px',padding:'0 16px'}}>
                    {
                        arrayConditions.map(p=>{
                            return<div className={'flex-row-vertical-center'}>
                                {/*类型card-project-tag*/}
                                <Select value={p.value}
                                        onInputKeyDown={(e) => {
                                            //要屏蔽所有的select
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        }}
                                        dropdownClassName={'shadow'}
                                        // onKeyDown={(e)=>{
                                        //     if (mapPropertyOpen[p.id]){
                                        //         //移动的是二级菜单
                                        //         e.nativeEvent.preventDefault();
                                        //         e.stopPropagation();
                                        //     }
                                        // }}
                                        style={{minWidth:ITEM_WIDTH,maxWidth:ITEM_WIDTH}}
                                        open={mapFilterType[p.id]}
                                        labelRender={(e)=>{
                                            if (e.label){
                                                return <div>{e.label}</div>
                                            }
                                            //properties...
                                            const property = arrayProperties.find(item=>item.id == e.value);
                                            return <div className={'flex-row-vertical-center'}>
                                                <img className={'img-14'}
                                                     src={getImagePathWithThemeSvg(property?.icon)}/>
                                                <span className={'ml-6 span-single-line'}>{property?.groupName == 'default'?t(property?.name):property?.name}</span>
                                            </div>
                                        }}
                                        onDropdownVisibleChange={(e) => {
                                            const newMap = {...mapFilterType};
                                            newMap[p.id] = e;
                                            if (mSelectIsProperty.current) {
                                                newMap[p.id] = true;
                                                mSelectIsProperty.current = false;
                                            }
                                            setMapFilterType(newMap);
                                        }}
                                        suffixIcon={<img className='img-mini-small-10' onClick={() => {
                                    }} src={getImagePathWithTheme('drop_down_select')}/>}
                                            dropdownStyle={{width: '228px', overflowY: 'auto'}}
                                            options={GET_ARRAY_PRIMARY_FILTER()}
                                            optionRender={(option)=>{
                                            return <>
                                                {
                                                    option.data.value == 'properties'? <Popover arrow={false} placement={'rightTop'}
                                                                                                open={mapPropertyOpen[p.id]}
                                                                                                onOpenChange={(e)=>{
                                                                                                    const newOpen = {...mapPropertyOpen};
                                                                                                    newOpen[p.id] = e;
                                                                                                    setMapPropertyOpen(newOpen);
                                                                                                }}
                                                                                                overlayInnerStyle={{margin:'0',padding:'4px 4px',maxHeight:'400px',overflow:'auto'}}
                                                                                                content={
                                                        <div className={'flex-col'} style={{gap:'3px 0px',minWidth:'228px'}}>
                                                            {
                                                                arrayProperties.map(pp=>{
                                                                    return <div className={'flex-row-vertical-center dropdown-item default-font-size default-font-family'} style={{padding:'0 12px',overflow:'hidden'}}
                                                                                onKeyDown={(e)=>{
                                                                                    console.log('xxx')
                                                                                }}
                                                                                onClick={(e)=>{
                                                                        const newOpen = {...mapPropertyOpen};
                                                                        newOpen[p.id] = false;
                                                                        setMapPropertyOpen(newOpen);

                                                                        //这里显示....
                                                                        const arrayConditionsNew = [...arrayConditions];
                                                                        const item: any = arrayConditionsNew.find(item => item.id == p.id);
                                                                        if (item) {
                                                                            item.type = 'properties';
                                                                            item.value = pp.id;
                                                                            item.operator = '';//操作符号
                                                                            item.arrayOperators = getFilterOperator(pp.type);
                                                                            item.secondValue = '';

                                                                            if (pp.type == 'checkbox'){
                                                                                item.operator = 'is';
                                                                                item.arrayValues = getFilterOptionValue(pp.type || pp.id);
                                                                            }else {
                                                                                item.operator = '';
                                                                            }
                                                                        }
                                                                        setArrayConditions(arrayConditionsNew);
                                                                    }}>
                                                                        <img className={'img-16'}
                                                                             src={getImagePathWithThemeSvg(pp.icon)}/>
                                                                        <span className={'ml-6 span-single-line'}>{pp.groupName == 'custom'?pp.name:t(pp.name)}</span>
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                        }>
                                                            <div className={'flex-row-vertical-center'}>
                                                                <img className={'img-16'}
                                                                     src={getImagePath(option.value == p.value ? 'check_black_white' : 'transparent')}/>
                                                                <span className={'ml-6'}>{option.label}</span>
                                                                <img className={'img-10'} style={{marginLeft:'auto'}} src={getImagePathWithTheme('arrow_right.svg')}/>
                                                            </div>
                                                        </Popover> :
                                                        <div className={'flex-row-vertical-center'} >
                                                            <img className={'img-16'}
                                                                 src={getImagePath(option.value == p.value ? 'check_black_white' : 'transparent')}/>
                                                            <span className={'ml-6'}>{option.label}</span>
                                                        </div>
                                                }
                                            </>
                                            }} onChange={(e) => {
                                                if (e == 'properties'){
                                                    return;
                                                }
                                    const arrayConditionsNew = [...arrayConditions];
                                    const item: any = arrayConditionsNew.find(item => item.id == p.id);
                                    if (item) {
                                            item.value = e;
                                            item.secondValue = '';
                                            if (e == 'type') {
                                                const arrayTmp = [...ARRAY_SECOND_FILTER_TYPE];
                                                item.arraySecondFilters = (arrayTmp)
                                            }else if (e == 'project') {
                                                item.arraySecondFilters = (mArrayProjects.current);
                                            }else if (e == 'tag'){
                                                item.arraySecondFilters = (mArrayTags.current);
                                            }
                                            item.type = undefined;
                                            item.operator = '';
                                            item.arrayOperators = [];
                                        }
                                        setArrayConditions(arrayConditionsNew);
                                    }} onSelect={(e)=>{
                                    if (e == 'properties'){
                                        mSelectIsProperty.current = true;
                                    }
                                }}>
                                </Select>

                                {
                                    //中间这个操作符
                                    (!p.type) &&
                                    <span className={'input-border ml-12 flex-row-vertical-center default-font-size'} style={{minWidth:'140px'}}>{(p.value == 'type' || p.value == 'project' || p.value == 'tag')?'Is':'Contains'}</span>
                                }

                                {
                                    //这个属性有很多...
                                    p.type &&
                                    <Select value={p.operator} open={mapFilterDropdownOpen[p.id]} style={{flexGrow: '1', flexShrink: '0',marginLeft:'12px',minWidth:'140px'}}
                                            onInputKeyDown={(e) => {
                                                //要屏蔽所有的select
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }
                                            }}
                                            dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                                            onDropdownVisibleChange={(e)=>{
                                                const newMap = {...mapFilterDropdownOpen};
                                                newMap[p.id] = e;
                                                if (p.type == 'checkbox') {
                                                    newMap[p.id] = false;
                                                }

                                                setMapFilterDropdownOpen(newMap);
                                            }}
                                            suffixIcon={p.type == 'checkbox'?<></>:<img className='img-mini-small-10' onClick={() => {
                                            }} src={getImagePathWithTheme('drop_down_select')}/>}
                                            dropdownStyle={{width: '228px', overflowY: 'auto'}}
                                            options={p.arrayOperators}
                                            optionRender={(option) => {
                                                return <div className={'flex-row-vertical-center'} style={{height:'100%',width:'100%'}} onClick={(e) => {
                                                    const arrayNewConditions = [...arrayConditions];
                                                    p.operator = option.value;
                                                    if (p.operator == 'isEmpty' || p.operator == 'isNotEmpty'){
                                                        p.secondValue = '';
                                                    }
                                                    setArrayConditions(arrayNewConditions);
                                                }}>
                                                    <span className={'ml-0'}>{option.label}</span>
                                                </div>
                                            }}>
                                    </Select>
                                }


                                {
                                    p.value == 'keyword'?<><input id={'txt-filter-'+p.id} className={'input-border'} value={p.secondValue}
                                                                  style={{minWidth:ITEM_WIDTH,marginLeft:'12px',borderRadius:'6px'}} onFocus={(event)=>{
                                            const txt = document.getElementById('txt-filter-'+p.id);
                                            if (txt){
                                                txt.style.border = `1px solid ${getInputBorderColor()}`
                                            }
                                        }} onBlur={(event)=>{
                                            const txt = document.getElementById('txt-filter-'+p.id);
                                            if (txt){
                                                txt.style.border = `1px solid var(--input-border-color)`
                                            }
                                        }}
                                                                  autoFocus={true} onChange={(event)=>{
                                            const arrayConditionsNew = [...arrayConditions];
                                            const item:any = arrayConditionsNew.find(item=>item.id == p.id);
                                            if (item) {
                                                item.secondValue = event.currentTarget.value;
                                            }
                                            setArrayConditions(arrayConditionsNew);
                                        }}/></>:(
                                        p.type ? <div style={{minWidth:ITEM_WIDTH,marginLeft:'12px',maxWidth:ITEM_WIDTH}}>{renderElementByType(p)}</div>:<Select value={p.secondValue} style={{minWidth:ITEM_WIDTH,marginLeft:'12px'}}
                                                                                                                                                                 onInputKeyDown={(e) => {
                                                                                                                                                                     //要屏蔽所有的select
                                                                                                                                                                     if (e.key === 'Enter') {
                                                                                                                                                                         e.preventDefault();
                                                                                                                                                                         e.stopPropagation();
                                                                                                                                                                     }
                                                                                                                                                                 }}
                                                                              showSearch={p.value == 'project' || p.value == 'tag'}
                                                                              optionFilterProp="label"
                                                                              suffixIcon={<img className='img-mini-small-10' onClick={() => {
                                                                              }} src={getImagePathWithTheme('drop_down_select')}/>}
                                                                              dropdownClassName={'shadow'}
                                                                              dropdownStyle={{width: ITEM_WIDTH, overflowY: 'auto'}}
                                                                              options={p.arraySecondFilters}
                                                                              optionRender={(option)=>{
                                                                                  return<div className={'flex-row-vertical-center'}>
                                                                                      <img className={'img-16'} src={getImagePath(option.value == p.secondValue?'check_black_white':'transparent')}/>
                                                                                      <span className={'ml-6 span-single-line'}>{option.label}</span>
                                                                                  </div>
                                                                              }} onSelect={(e,o)=>{
                                            const arrayConditionsNew = [...arrayConditions];
                                            const item:any = arrayConditionsNew.find(item=>item.id == p.id);
                                            if (item) {
                                                item.secondValue = e;
                                                //这里如果是tag的话要用tag.name....
                                                if (item.value == 'tag') {
                                                    item.secondName = o.label
                                                }
                                            }
                                            setArrayConditions(arrayConditionsNew);
                                        }}>
                                        </Select>
                                    )
                                }


                                <img className={'img-16 ml-12 cursor-pointer'} src={getImagePathWithTheme('filter_remove')} onClick={()=>{

                                    const arrayNew = [...arrayConditions];
                                    const nIndex = arrayNew.findIndex(item=>item.id == p.id);
                                    arrayNew.splice(nIndex,1);
                                    setArrayConditions(arrayNew);

                                }}/>
                            </div>
                        })
                    }

                </div>

            </div>

            <div className={isNewCustomFilter?'flex-center mt-32 mb-4':'flex-row-vertical-center mt-32 mb-4'}>
                {
                    !isNewCustomFilter &&
                    <Button
                        // disabled={isStringNullOrEmpty(selectFile)}
                        className='large-w-button button-solid-style-delete font-size-14 font-family-medium'
                        type="primary"
                        onClick={async () => {
                            window.showMessageBox(t("Delete filter"),t("SureToDeleteFilter").replace('{0}',customFilter?.name),t("Cancel"),t("Delete"),null,()=>{
                                deleteCustomFilter(customFilter.id).then(res=>{
                                    if (window.refreshList['refreshCustomFilter']){
                                        window.refreshList['refreshCustomFilter'](true);
                                    }
                                });

                                props.onCloseCallback();
                            })
                        }}
                        style={{
                            minWidth: '120px',
                            background:'#FFEDEC',
                            color:'#FF5449'
                        }}>{t("Delete filter")}</Button>
                }

                <div className={'flex-row-vertical-center'} style={{marginLeft:isNewCustomFilter?'0px':'auto'}}>
                    <Button
                        style={{height: '34px', minWidth: '120px'}}
                        className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                        onClick={() => {
                            setIsShowDialog(false);
                        }}>{t("Cancel")}</Button>
                    <Button
                        // disabled={isStringNullOrEmpty(selectFile)}
                        className='large-w-button button-solid-style font-size-14 font-family-medium'
                        type="primary"
                        id={'btn-update-filter'}
                        onClick={async () => {
                            if (!customFilter.name) {
                                message.error(t("InputFilterName"));
                                return;
                            }
                            const arrayFilters = await getCustomFilterList();
                            const nLength = arrayFilters.filter(p=>p.name.toLowerCase() == customFilter.name && p.id != customFilter.id);
                            if (nLength > 0) {
                                message.error(t("NameExist"));
                                return;
                            }
                            if (arrayConditions.length == 0) {
                                message.error(t("InputConditions"));
                                return;
                            }

                            let hasEmpty = false;
                            //如果是属性，空的不要...
                            for (let i=arrayConditions.length-1;i>=0;i--){
                                const item = arrayConditions[i];
                                if (item.type == 'properties'){
                                    if (!item.operator){
                                        hasEmpty = true;
                                        // arrayConditions.splice(i,1);  不要删。。。
                                    }else {
                                        if (item.operator == 'isEmpty' || item.operator == 'isNotEmpty'){

                                        }else {
                                            if (!item.secondValue){
                                                hasEmpty = true;
                                                // arrayConditions.splice(i,1);不要删。。。
                                            }
                                        }
                                    }
                                }
                            }
                            if (hasEmpty){
                                message.error(t('PleaseCompleteTheFilterCondition'));
                                return;
                            }


                            //移除临时的字段
                            arrayConditions.forEach(p=>{
                                delete p.arraySecondFilters;
                            })

                            //更新....
                            updateCustomFilter({...customFilter,arrayConditions:arrayConditions}).then(res=>{
                                //刷新....
                                if (window.refreshList['refreshCustomFilter']){
                                    window.refreshList['refreshCustomFilter']();
                                }
                                props.onCloseCallback();
                            })
                        }}
                        style={{
                            marginLeft: '12px',
                            minWidth: '120px'
                        }}
                        htmlType={"submit"}>{isNewCustomFilter?t("Save filter"):t("Update filter")}</Button>
                </div>
            </div>
        </div>
    </Modal>
})

export default DialogCreateNewFilter;



























